import { render } from "./PageHome.vue?vue&type=template&id=6656812d&ts=true"
import script from "./PageHome.vue?vue&type=script&lang=ts"
export * from "./PageHome.vue?vue&type=script&lang=ts"

import "./PageHome.vue?vue&type=style&index=0&id=6656812d&lang=scss"

import exportComponent from "D:\\Users\\asato\\Documents\\GitHub\\suite_totalling_web\\totalling_web\\src\\html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__